import * as React from "react";
const SvgMinusIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 2, viewBox: "0 0 16 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 6.99382e-07V2L0 2L8.74229e-08 0L16 6.99382e-07Z", fill: "currentColor" }));
export default SvgMinusIcon;
